import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "iconOpen", "iconClose", "toggle"]

  connect() {
    this.open = false
    this._handleResize = this._handleResize.bind(this)
    window.addEventListener("resize", this._handleResize)
    this._update()
  }

  disconnect() {
    window.removeEventListener("resize", this._handleResize)
  }

  toggle() {
    this.open = !this.open
    this._update()
  }

  _handleResize() {
    if (this._isDesktop()) {
      this.open = false
    }
    this._update()
  }

  _update() {
    const isDesktop = this._isDesktop()

    if (this.hasMenuTarget) {
      if (isDesktop) {
        this.menuTarget.classList.remove("hidden")
      } else {
        this.menuTarget.classList.toggle("hidden", !this.open)
      }
    }

    if (this.hasIconOpenTarget) {
      this.iconOpenTarget.classList.toggle("hidden", this.open || isDesktop)
    }

    if (this.hasIconCloseTarget) {
      this.iconCloseTarget.classList.toggle("hidden", !this.open || isDesktop)
    }

    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", this.open ? "true" : "false")
      this.toggleTarget.classList.toggle("hidden", isDesktop)
    }
  }

  _isDesktop() {
    return window.matchMedia
      ? window.matchMedia("(min-width: 640px)").matches
      : window.innerWidth >= 640
  }
}


